import * as React from "react";
import { Input } from "./ui/input";

/**
 * Summa kiritish maydoni — yozilayotganda minglikni bo'sh joy bilan ajratib
 * ko'rsatadi (1000 → "1 000"). Tashqi qiymat (`value`) va `onChange` doim XOM
 * raqamli satr (faqat raqamlar) bilan ishlaydi — so'm butun sonlarda. Karetka
 * o'rni reformatdan keyin saqlanadi (o'rtaga yozganda sakramaydi).
 */
function rawDigits(s: string): string {
  // Faqat raqamlar — kasr ishlatilmaydi (so'm butun).
  return s.replace(/\D/g, "").replace(/^0+(?=\d)/, "");
}

function group(raw: string): string {
  const d = rawDigits(raw);
  if (d === "") return "";
  return d.replace(/\B(?=(\d{3})+(?!\d))/g, " ");
}

type Props = Omit<
  React.InputHTMLAttributes<HTMLInputElement>,
  "value" | "onChange" | "type"
> & {
  value: string;
  /** Xom raqamli satr (guruhsiz) bilan chaqiriladi. */
  onChange: (raw: string) => void;
};

export const MoneyInput = React.forwardRef<HTMLInputElement, Props>(
  function MoneyInput({ value, onChange, inputMode, ...rest }, ref) {
    const innerRef = React.useRef<HTMLInputElement | null>(null);
    // Reformatdan keyin tiklash uchun "karetkadan oldingi raqamlar soni".
    const caretRef = React.useRef<number | null>(null);
    // Har bosishda majburiy qayta render — raqamga aylanmaydigan belgini (harf,
    // nuqta) kiritganda ham nazoratchi qiymat darhol tiklanadi.
    const [, force] = React.useReducer((x) => x + 1, 0);
    const display = group(value ?? "");

    React.useLayoutEffect(() => {
      const el = innerRef.current;
      if (!el || caretRef.current == null) return;
      const target = caretRef.current;
      caretRef.current = null;
      let seen = 0;
      let pos = 0;
      while (pos < el.value.length && seen < target) {
        if (el.value[pos] !== " ") seen++;
        pos++;
      }
      el.setSelectionRange(pos, pos);
    });

    function setRef(node: HTMLInputElement | null) {
      innerRef.current = node;
      if (typeof ref === "function") ref(node);
      else if (ref) (ref as React.MutableRefObject<HTMLInputElement | null>).current = node;
    }

    function handleChange(e: React.ChangeEvent<HTMLInputElement>) {
      const el = e.target;
      const caret = el.selectionStart ?? el.value.length;
      caretRef.current = rawDigits(el.value.slice(0, caret)).length;
      onChange(rawDigits(el.value));
      force();
    }

    return (
      <Input
        ref={setRef}
        type="text"
        inputMode={inputMode ?? "numeric"}
        value={display}
        onChange={handleChange}
        {...rest}
      />
    );
  },
);
